import { createSelector } from '@reduxjs/toolkit';
import { selectLocation } from './selectLocation';

export const selectHasDistricts = createSelector(selectLocation, currentLocation => {
  if (currentLocation === 'moscow_mo') {
    return false;
  }

  return currentLocation === 'spb_lo' || currentLocation.hasDistricts;
});
